import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';
import { WarningType } from '@shared/enums/dpr';
import { DprDetails } from '@shared/models/dpr';
import { SubprojectConfigurationCustomNames } from '@shared/models/project-setup';

@Pipe({ name: 'warningTooltip' })
export class WarningTooltipPipe implements PipeTransform {
  transform(
    data: DprCard | DprDetails,
    customNames: SubprojectConfigurationCustomNames,
    property: string,
    tabNameProperty: string
  ): string {
    const reportMissingText = $localize`:@@dpr.warningTooltipPipe.attrReportMissingWarning:report is missing`;

    switch (data?.[property]) {
      case WarningType.Activity:
        return $localize`:@@dpr.warningTooltipPipe.attrActivityWarning:Error in time recording`;
      case WarningType.Weather:
        return `${customNames?.weatherTabName} ` + reportMissingText;
      case WarningType.HSE:
        return `${customNames?.hseTabName} ` + reportMissingText;
      case WarningType.Consumable:
        return `${customNames?.consumablesTabName} ` + reportMissingText;
      case WarningType.Personnel:
        return `${customNames?.personnelTabName} ` + reportMissingText;
      case WarningType.CustomData:
        return $localize`:@@dpr.warningTooltipPipe.attrCustomDataWarning:Missing mandatory custom data`;
      case WarningType.Progress:
        return `${customNames?.progressTabName} ` + reportMissingText;
      case WarningType.ProgressWithoutTarget:
        return (
          `${customNames?.progressWithoutTargetTabName} ` + reportMissingText
        );
      case WarningType.TableOfColumn:
        return `${data[tabNameProperty]} ` + reportMissingText;
      default:
        return null;
    }
  }
}
